import { AlertCircle, X } from "lucide-react";

interface Props {
  message: string;
  onDismiss: () => void;
}

export function ErrorBanner({ message, onDismiss }: Props) {
  return (
    <div className="card p-3 mb-4 border-fuscia/40 flex items-start gap-3 bg-fuscia/5">
      <AlertCircle className="text-fuscia shrink-0 mt-0.5" size={18} />
      <div className="flex-1 text-sm text-midnight">{message}</div>
      <button onClick={onDismiss} className="text-grape hover:text-midnight" aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  );
}
